/**
 * @packageDocumentation
 * @module      EmcPacket.ts
 * @description Encapsulates the EMC packet JSON data in structured fields.
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
import EmcSubsystemsVersionData from "./EmcSubsystemsVersionData";
import { EmcDataParameterAllTabs } from "./EmcDataParameterAllTabs";
import { FaultMessageDto } from "./FaultMessageDto";
import { StateMessageDto } from "./StateMessageDto";
import EmcConsts from "./EmcConsts";
import EmcFaultCounts from "./EmcFaultCounts";
class EmcPacket {
    constructor(packetId) {
        this.packetId = packetId;
        this.systemId = "";
        this.timestamp = "";
        this.isControlSide = false;
        this.emcDataParameterAllTabs = null;
        this.emcSubsystemsVersionData = null;
        this.currentFaultMessages = [];
        this.removedFaultMessages = [];
        this.stateChangeMessages = [];
        this.latency = EmcConsts.NOT_AVAILABLE;
        this.controlConnectionStatus = EmcConsts.NOT_AVAILABLE;
        this.communicationFaultCount = 0;
        this.faultCounts = new EmcFaultCounts();
    }
    ;
}
EmcPacket.EmcPacketBuilder = class {
    static fromJson(json) {
        let emcPacket = null;
        if (json && json.SystemId && json.PacketId) {
            let packetId = json.PacketId;
            if (packetId > 0) {
                emcPacket = new EmcPacket(packetId);
                emcPacket.systemId = json.SystemId;
                emcPacket.timestamp = json.Date;
                emcPacket.isControlSide = json.IsControlSide;
                emcPacket.emcDataParameterAllTabs = EmcDataParameterAllTabs.fromJSON(json);
                emcPacket.emcSubsystemsVersionData = EmcSubsystemsVersionData.fromJSON(json);
                emcPacket.faultCounts = EmcFaultCounts.fromJson(json);
                json.CurrentFaults.forEach(faultMessage => {
                    emcPacket.currentFaultMessages.push(FaultMessageDto.fromJson(faultMessage));
                });
                json.RemovedFaults.forEach(faultMessage => {
                    emcPacket.removedFaultMessages.push(FaultMessageDto.fromJson(faultMessage));
                });
                json.ChangedStates.forEach(stateMessage => {
                    emcPacket.stateChangeMessages.push(StateMessageDto.fromJson(stateMessage));
                });
                if (json.Latency)
                    emcPacket.latency = json.Latency;
                if (json.ControlConnectionStatus)
                    emcPacket.controlConnectionStatus = json.ControlConnectionStatus;
                if (json.CommunicationFaultCount)
                    emcPacket.communicationFaultCount = json.CommunicationFaultCount;
            }
        }
        return emcPacket;
    }
};
export default EmcPacket;
//# sourceMappingURL=EmcPacket.js.map